<script>
    import { Percent } from 'lucide-svelte';
    import { Render } from "svelte-headless-table";
    let discountPercent = 0;

    export let cell;

    function getStrokeDasharray(percent) {
        return `${percent} 100`; // 2.8 est basé sur le périmètre du cercle (approximation)
    }
</script>
<!--   
  <div class="rounded-full border w-10 h-10 text-xs flex items-center justify-center">
    <div >
      <Render of={cell.row.cellForId["discountPercent"].render()} />
    </div>
  </div> -->

  <div class="relative flex items-center justify-center w-10 h-10 z-5">
    <svg class="absolute top-0 left-0 w-full h-full" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
      <circle
        class="text-secondary-foreground/15"  
        stroke-width="4"
        stroke="currentColor"
        fill="none"
        cx="18" cy="18" r="16"
      />
      <circle
        class="text-yellow-500"  
        stroke-width="4"
        stroke="currentColor"
        fill="none"
        cx="18" cy="18" r="16"
        stroke-dasharray="{getStrokeDasharray(cell.row.cellForId["discountPercent"].value)}"
        stroke-dashoffset="0"
      />
    </svg>
    <!-- Texte centré -->
    <div class="text-xs">
       <Render of={cell.row.cellForId["discountPercent"].render()} />
    </div>
  </div>

  <style>
    .circle {
      transform: rotate(-90deg); /* Pour que l'arc commence du haut */
      transform-origin: center;
    }
  </style>